// the question dialog and busy buttons.
import { esc, icon } from './core.ts';
import { validateForm } from './validation.ts';

/** What the question dialog asks; danger = a red «yes» (delete, reject). */
export interface ConfirmOptions {
  title: string;
  text?: string;
  ok?: string;
  danger?: boolean;
}

// ---------------- confirm dialog + busy buttons ----------------
export function confirmDialog({ title, text, ok = 'تأیید', danger = true }: ConfirmOptions): Promise<boolean> {
  return new Promise(resolve => {
    const d = document.createElement('dialog');
    d.className = 'ds-dialog ds-ask';
    // T-126: the question dialog — a tinted mark above the question, the body under it, the answer buttons last
    d.innerHTML =
      `<div class="ds-confirm ds-ask"><div class="head"><span class="mark${danger ? '' : ' normal'}">${icon(danger ? 'trash' : 'check-circle')}</span><div><b>${esc(title)}</b>${text ? `<p>${esc(text)}</p>` : ''}</div></div>` +
      `<div class="acts"><button type="button" class="btn btn-ghost" value="cancel">انصراف</button><button type="button" class="btn ${danger ? 'btn-danger' : 'btn-primary'}" value="ok">${esc(ok)}</button></div></div>`;
    document.body.appendChild(d);
    const done = (v: boolean): void => {
      d.close();
      d.remove();
      resolve(v);
    };
    d.addEventListener('cancel', e => {
      e.preventDefault();
      done(false);
    });
    d.querySelectorAll('button').forEach(b => b.addEventListener('click', () => done(b.value === 'ok')));
    d.showModal();
    d.querySelector<HTMLButtonElement>('button[value="cancel"]')!.focus();
  });
}
export function initConfirm(): void {
  document.addEventListener(
    'click',
    async e => {
      const el = (e.target as Element).closest<HTMLButtonElement>('[data-ds-confirm]');
      if (!el || el.dataset.dsConfirmed) return;
      e.preventDefault();
      e.stopPropagation();
      const ok = await confirmDialog({
        title: el.dataset.dsConfirm!,
        text: el.dataset.dsConfirmText,
        ok: el.dataset.dsConfirmOk || 'تأیید',
        danger: el.dataset.dsConfirmKind !== 'normal',
      });
      if (!ok) return;
      el.dataset.dsConfirmed = '1';
      if (el.form && el.type === 'submit') el.form.requestSubmit(el);
      else el.click();
      delete el.dataset.dsConfirmed;
    },
    true,
  );
  document.addEventListener('submit', e => {
    const form = e.target as HTMLFormElement;
    if (form.dataset.dsValidate !== undefined && !validateForm(form)) {
      e.preventDefault();
      return;
    }
    const btn = (e.submitter || form.querySelector('[type="submit"]')) as HTMLButtonElement | null;
    if (btn?.dataset.busyText && !e.defaultPrevented) {
      setTimeout(() => {
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        btn.innerHTML = `<span class="ds-spin" aria-hidden="true"></span>${esc(btn.dataset.busyText)}`;
      });
    }
  });
}
